import * as TYPES from './action-types.js';

/**
 * poi页面搜索站点类型：上车站/下车站
 * @type {{off: string, on: string}}
 */
export const POI__STOP_TYPE = {
	on: 'on',
	off: 'off'
};

/**
 * poi搜索框placeholder
 * @type {{off: string, on: string}}
 */
export const POI__PLACEHOLDER = {
	on: '您在哪儿上车',
	off: '输入您的目的地'
};

/**
 * poi搜索结果列表类型：autocomplete: 联想结果，search: 后台查询结果
 * @type {{search: string, autocomplete: string}}
 */
export const POI__LIST_TYPE = {
	autocomplete: 'autocomplete',
	search: 'search'
};

export default {
	namespaced: true,
	state: {
		stopType: POI__STOP_TYPE.on,
		placeholder: POI__PLACEHOLDER.on,
		listType: POI__LIST_TYPE.autocomplete,
		searchingPoint: []
	},
	getters: {
		stopType: state => state.stopType,
		placeholder: state => state.placeholder,
		listType: state => state.listType,
		searchingPoint: state => state.searchingPoint
	},
	mutations: {
		[TYPES.POI__SET_STOP_TYPE](state, payload) {
			state.stopType = payload;
		},
		[TYPES.POI__SET_PLACEHOLDER](state, payload) {
			state.placeholder = POI__PLACEHOLDER[payload];
		},
		[TYPES.POI__SET_LIST_TYPE](state, payload) {
			state.listType = payload;
		},
		[TYPES.POI__SET_SEARCHING_POINT](state, payload) {
			state.searchingPoint = payload;
		}
	},
	actions: {
		[TYPES.POI__SET_STOP_TYPE]({commit}, payload) {
			commit(TYPES.POI__SET_STOP_TYPE, payload);
		},
		[TYPES.POI__SET_PLACEHOLDER]({commit}, payload) {
			commit(TYPES.POI__SET_PLACEHOLDER, payload);
		},
		[TYPES.POI__SET_LIST_TYPE]({commit}, payload) {
			commit(TYPES.POI__SET_LIST_TYPE, payload);
		},
		[TYPES.POI__SET_SEARCHING_POINT]({commit}, payload) {
			commit(TYPES.POI__SET_SEARCHING_POINT, payload);
		}
	}
};
